import { connect } from 'react-redux';
import Component from './Component';

import componentDidMount from './Handlers/componentDidMount';
import onClickCancel from './Handlers/onClickCancel';
import onClickSubmit from './Handlers/onClickSubmit';
import onClickDelete from './Handlers/onClickDelete';

const mapStateToProps = (state, ownProps) => ({
  submitting: state.modals.SupplierItem.submitting,
  supplierItem: state.modals.SupplierItem.supplierItem || ownProps.supplierItem,
});

const actionCreators = {
  componentDidMount,
  onClickCancel,
  onClickSubmit,
  onClickDelete,
};

export default connect(mapStateToProps, actionCreators)(Component);
